import { AxiosError, isAxiosError } from 'axios';

interface IOverlappingJobErrorResponse {
  errorCode: string;
  error: string;
}

export class OverlappingJobError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'OverlappingJobError';
  }

  static fromAxiosError(error: unknown): OverlappingJobError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IOverlappingJobErrorResponse>;

    if (axiosError.response?.data?.errorCode === 'OVERLAPPING_SHIFTS') {
      const errorMessage = axiosError.response.data.error || error.message;
      return new OverlappingJobError(errorMessage);
    }

    return null;
  }
}
